module.exports = __webpack_public_path__ + "img/alarm.3c656479.svg";